import React, { useState } from "react"
import { FormattedMessage } from "react-intl"
import { Heading } from "@walmart-web/livingdesign-components"
import {
	AdministrationOptions,
	Views,
} from "components/UserManagement/interfaces"
import { disabledList, EditComponents } from "./constants"
import Button from "components/Shared/Button"

interface EditProps {
	section: AdministrationOptions
	setView: (value: Views) => void
	selection: any
	setSelection: (value: any) => void
}

const Edit: React.FC<EditProps> = ({ section, setView, selection }) => {
	const { component, endpoint } = EditComponents[section]
	const [data, setData] = useState(selection)

	return (
		<div className="administration-form">
			<Heading UNSAFE_className="title" as="h2">
				<FormattedMessage
					id={`phronesis.usermanagement.${section}.edit.title`}
				/>
			</Heading>

			<div className="text">
				<FormattedMessage id="phronesis.usermanagement.requiredFields" />
			</div>

			{React.cloneElement(component, { setData, data, disabled: disabledList })}

			<div className="buttons">
				<Button onClick={() => setView("List")}>
					<FormattedMessage id="phronesis.usermanagement.cancel" />
				</Button>
				<Button
					variant="primary"
					onClick={() => {
						endpoint(data).then(() => {
							setView("List")
						})
					}}
				>
					<FormattedMessage id="phronesis-usermanagement.edit.button" />
				</Button>
			</div>
		</div>
	)
}

export default Edit
